exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-4092e1e6] .el-autocomplete-suggestion li{line-height:25px!important}", ""]);

// exports
